<div class="raw-response-modal">
	<div class="modal-header">
		<h2 class="modal-title">
			<ng-container *ngIf="data.context === 'inventory'">
				<span class="title-label">Inventory sync</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">success</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'sku_push'">
				<span class="title-label">Push SKU</span>
				<span *ngIf="data.stockid" class="title-order">{{ data.stockid }}</span>
				<span *ngIf="!data.stockid" class="title-order">Push in-scope SKUs</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">success</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'inbound'">
				<span class="title-label">Inbound order</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">success</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'open_orders'">
				<span class="title-label">Open B2B orders</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'shipments'">
				<span class="title-label">Shipments poll</span>
			</ng-container>
			<ng-container *ngIf="data.context !== 'inventory' && data.context !== 'sku_push' && data.context !== 'inbound' && data.context !== 'open_orders' && data.context !== 'shipments'">
				<span class="title-label">Raw export</span>
				<span class="title-order">Order {{ data.orderno }}</span>
				<span *ngIf="data.export_status === 'failed'" class="badge-failed">failed</span>
				<span *ngIf="data.export_status === 'exported'" class="badge-exported">exported</span>
			</ng-container>
		</h2>
		<div class="modal-actions">
			<button *ngIf="data.orderno" mat-raised-button color="primary" (click)="sendExport()" [disabled]="sending" matTooltip="Send order to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : (isPreviewMode ? 'Send' : 'Send again') }}</span>
			</button>
			<button *ngIf="data.context === 'inventory'" mat-raised-button color="primary" (click)="sendInventorySync()" [disabled]="sending" matTooltip="Send inventory sync request to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : 'Send' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && data.stockid" mat-raised-button color="primary" (click)="sendSkuPush()" [disabled]="sending" matTooltip="Push this SKU to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : 'Send' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && !data.stockid" mat-stroked-button (click)="loadSkuPushList()" [disabled]="skuPushListLoading" matTooltip="Load list of in-scope SKUs">
				<mat-spinner *ngIf="skuPushListLoading" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!skuPushListLoading">refresh</mat-icon>
				<span class="send-label">{{ skuPushListLoading ? 'Loading…' : 'Load list' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && !data.stockid" mat-raised-button color="primary" (click)="sendBatchSkuPush()" [disabled]="!canSendBatch()" matTooltip="Send pending SKUs in batches of 50; continues automatically until all are sent">
				<mat-spinner *ngIf="skuPushBatchSending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!skuPushBatchSending">send</mat-icon>
				<span class="send-label">{{ skuPushBatchSending ? 'Sending…' : 'Send batch (50)' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && !data.stockid" mat-stroked-button (click)="exportAllSkuPushResults()" matTooltip="Export all results as JSON">
				<mat-icon>download</mat-icon>
				<span class="send-label">Export all</span>
			</button>
			<button *ngIf="data.context === 'inbound'" mat-raised-button color="primary" (click)="sendInbound()" [disabled]="sending" matTooltip="Send inbound order to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : (isPreviewMode ? 'Send' : 'Send again') }}</span>
			</button>
			<button *ngIf="data.context === 'shipments'" mat-raised-button color="primary" (click)="sendShipmentsPoll()" [disabled]="sending" matTooltip="Send shipment poll request and refresh response">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">sync</mat-icon>
				<span class="send-label">{{ sending ? 'Polling…' : 'Poll again' }}</span>
			</button>
			<button *ngIf="requestPayloadJson" mat-icon-button (click)="copyToClipboard()" [matTooltip]="copied ? 'Copied!' : 'Copy all'" [class.copied]="copied">
				<mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
			</button>
			<button mat-icon-button (click)="close()" matTooltip="Close">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
	<div class="modal-body">
		<section class="payload-section" *ngIf="!(data.context === 'sku_push' && !data.stockid)">
			<div class="section-header">
				<h3 class="section-title">{{ data.context === 'inbound' ? 'Inbound payload' : (data.context === 'shipments' ? 'Data being sent (request)' : (data.context === 'open_orders' ? 'Request' : 'Payload we sent')) }}</h3>
				<button *ngIf="requestPayloadJson" mat-icon-button (click)="copyRequest()" [matTooltip]="copiedRequest ? 'Copied!' : 'Copy'" [class.copied]="copiedRequest">
					<mat-icon>{{ copiedRequest ? 'check' : 'content_copy' }}</mat-icon>
				</button>
			</div>
			<pre *ngIf="requestPayloadJson" class="response-pre">{{ requestPayloadJson }}</pre>
			<p *ngIf="!requestPayloadJson" class="payload-missing">{{ data.context === 'inventory' ? 'Request payload was not stored for this sync.' : (data.context === 'sku_push' ? 'Send to see the payload and response.' : (data.context === 'inbound' ? 'No inbound payload.' : 'Request payload was not stored for this export. Re-export the order to see the payload we send.')) }}</p>
		</section>
		<p *ngIf="data.context === 'sku_push' && !data.stockid && skuPushRows.length > 0" class="small text-muted mb-2">
			{{ skuPushRows.length }} SKUs loaded
			<span *ngIf="skuPushListTotal != null">({{ skuPushListTotal }} total)</span>
			— {{ skuPushPendingCount }} pending, {{ skuPushSucceededCount }} ok, {{ skuPushFailedCount }} failed
		</p>
		<section class="payload-section" *ngIf="data.context === 'sku_push' && !data.stockid">
			<div class="section-header d-flex justify-content-between align-items-center flex-wrap">
				<h3 class="section-title mb-0">SKU list</h3>
				<div class="d-flex align-items-center gap-2">
					<mat-form-field appearance="outline" class="sku-push-search">
						<mat-label>Search SKU</mat-label>
						<input matInput [(ngModel)]="skuPushSearch" placeholder="Type to search server (no Load list needed)">
						<button mat-icon-button matSuffix (click)="skuPushSearch = ''" *ngIf="skuPushSearch" matTooltip="Clear">
							<mat-icon>close</mat-icon>
						</button>
					</mat-form-field>
					<button *ngIf="skuPushRows.length > 0 && skuPushListTotal != null && skuPushRows.length < skuPushListTotal" mat-stroked-button (click)="loadMoreSkuPushList()" [disabled]="skuPushListLoading">Load more</button>
				</div>
			</div>
			<table mat-table [dataSource]="skuPushRowsPaged" class="w-100 compact-table mb-2">
				<ng-container matColumnDef="stockid">
					<th mat-header-cell *matHeaderCellDef>SKU</th>
					<td mat-cell *matCellDef="let row">{{ row.stockid }}</td>
				</ng-container>
				<ng-container matColumnDef="payload">
					<th mat-header-cell *matHeaderCellDef>Payload</th>
					<td mat-cell *matCellDef="let row">
						<button mat-icon-button (click)="viewPayload(row)" matTooltip="View request payload for this SKU">
							<mat-icon>description</mat-icon>
						</button>
					</td>
				</ng-container>
				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef>Status</th>
					<td mat-cell *matCellDef="let row">
						<span *ngIf="row.status === 'pending'" class="badge badge-secondary">Pending</span>
						<span *ngIf="row.status === 'sending'" class="badge badge-warning">Sending…</span>
						<span *ngIf="row.status === 'success'" class="badge badge-success">Success</span>
						<span *ngIf="row.status === 'failed'" class="badge badge-danger">Failed</span>
					</td>
				</ng-container>
				<ng-container matColumnDef="message">
					<th mat-header-cell *matHeaderCellDef>Message</th>
					<td mat-cell *matCellDef="let row" class="message-cell">{{ row.message || '–' }}</td>
				</ng-container>
				<ng-container matColumnDef="send">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<button mat-icon-button color="primary" (click)="sendOneRow(row)" [disabled]="row.status !== 'pending'" matTooltip="Send this SKU">
							<mat-icon>send</mat-icon>
						</button>
					</td>
				</ng-container>
				<ng-container matColumnDef="view_raw">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<button mat-icon-button color="accent" (click)="openRawForSkuRow(row)" [disabled]="row.fullResult == null" matTooltip="View raw response">
							<mat-icon>code</mat-icon>
						</button>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="['stockid', 'payload', 'status', 'message', 'send', 'view_raw']"></tr>
				<tr mat-row *matRowDef="let r; columns: ['stockid', 'payload', 'status', 'message', 'send', 'view_raw'];"></tr>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell text-center text-muted py-3" colspan="6">{{ skuPushListLoading ? 'Loading…' : (skuPushSearch ? 'No SKUs match the search.' : 'Click Load list to fetch in-scope SKUs.') }}</td>
				</tr>
			</table>
			<mat-paginator
				*ngIf="skuPushRowsFiltered.length > 0"
				[length]="skuPushRowsFiltered.length"
				[pageSize]="skuPushPageSize"
				[pageIndex]="skuPushPageIndex"
				[pageSizeOptions]="[10, 25, 50, 100]"
				(page)="onSkuPushPage($event)"
				showFirstLastButtons
				aria-label="SKU list page">
			</mat-paginator>
		</section>
		<section class="payload-section" *ngIf="!(data.context === 'sku_push' && !data.stockid)">
			<div class="section-header">
				<h3 class="section-title">{{ data.context === 'sku_push' && data.stockid ? '3PL raw response' : 'Response we received' }}</h3>
				<button *ngIf="!isPreviewMode && responseJson" mat-icon-button (click)="copyResponse()" [matTooltip]="copiedResponse ? 'Copied!' : 'Copy'" [class.copied]="copiedResponse">
					<mat-icon>{{ copiedResponse ? 'check' : 'content_copy' }}</mat-icon>
				</button>
			</div>
			<p *ngIf="isPreviewMode" class="payload-missing">Not sent yet. Use the Send button above to send the request and see the response.</p>
			<p *ngIf="!isPreviewMode && circuitOpen" class="small text-muted mb-1">No request was sent to the 3PL (circuit breaker open). Below is the actual response from our system.</p>
			<pre *ngIf="!isPreviewMode && responseJson" class="response-pre">{{ responseJson }}</pre>
		</section>
	</div>
</div>
